import { CircularProgress } from "@mui/material";
import { dcolors } from "corexxx";
import { DCol } from "./DCol";
import { DText } from "./DText";

export const DLoadingUI = () => {
  return (
    <DCol style={{ alignItems: "center" }}>
      <CircularProgress size={20} />
      <DText style={{ color: dcolors.pallets.grey600, marginTop: 10 }}>
        Loading ...
      </DText>
    </DCol>
  );
};
